import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import type { SrmTicketModel } from '@libs/services/models';
import { LuxonDatePipe } from '@libs/shared/ui';

@Component({
  selector: 'ui-srm-ticket-item',
  standalone: true,
  templateUrl: './srm-ticket-item.component.html',
  styleUrls: ['./srm-ticket-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LuxonDatePipe,
  ],
})
export class SrmTicketItemComponent {
  public ticket: InputSignal<SrmTicketModel> = input.required();
}
